<td class="participant-list-column">
  <div class="data-wrapper">
    <div class="status">
      <div
        [title]="
          (conversationIsOpen()
            ? 'SHARED.PARTICIPANT_LIST.ONLINE'
            : 'SHARED.PARTICIPANT_LIST.OFFLINE'
          ) | translate
        "
        class="status-icon"
        [ngClass]="{
          online: conversationIsOpen(),
          offline: !conversationIsOpen(),
        }"></div>
    </div>
    <div class="data">
      <div class="name" title="{{ participant().displayName }}">
        {{ participant().displayName }}
      </div>
      <div class="role">
        {{ 'SHARED.PARTICIPANT_LIST.SHORT_KIND_' + participant().kind | translate }}
      </div>
    </div>
    <div class="is-typing">
      @if (isTyping()) {
        <orbit-fa-icon class="typing-icon" [iconName]="typingIcon" [animation]="'fade'" />
      }
    </div>
  </div>
</td>
<td class="participant-list-column text-right">
  <div class="last-seen">
    {{ (participant().hadConversationOpenAt | date: 'HH:mm dd.MM') ?? '-' }}
  </div>
</td>
<td class="participant-list-column text-right unread-messages">
  <orbit-notification
    [inline]="true"
    [amount]="participant().unreadMessagesCount ?? 0"
    [transparent]="participant().unreadMessagesCount === 0" />
</td>
<td class="participant-list-column menu-column">
  @if (
    this.participant().kind !== ParticipantKind.Workflow &&
    (this.user()?.role === UserRole.Owner ||
      this.participant().userId === this.user()?.id ||
      this.participant().kind === ParticipantKind.Client)
  ) {
    <orbit-button
      [testId]="'btn-participant-list-item-menu'"
      [icon]="menuIcon"
      [size]="'small'"
      [flat]="true"
      (onClick)="openMenu($event)" />
  }
</td>
